"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetPostData = exports.GetApiKey = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _sitecoreJssReactForms = require("@sitecore-jss/sitecore-jss-react-forms");
var _conditionalRendering = _interopRequireWildcard(require("../../components/JSSForm/conditionalRendering"));
var _customSingleLineText = _interopRequireDefault(require("../../components/JSSForm/customSingleLineText"));
var _customTextArea = _interopRequireDefault(require("../../components/JSSForm/customTextArea"));
var _customButton = _interopRequireDefault(require("../../components/JSSForm/customButton"));
var _customTextField = _interopRequireDefault(require("../../components/JSSForm/customTextField"));
var _customSection = _interopRequireDefault(require("../../components/JSSForm/customSection"));
var _customCheckbox = _interopRequireDefault(require("../../components/JSSForm/customCheckbox"));
var _customCheckboxList = _interopRequireDefault(require("../../components/JSSForm/customCheckboxList"));
var _customRecaptcha = _interopRequireDefault(require("../../components/JSSForm/customRecaptcha"));
var _customRichTextField = _interopRequireDefault(require("../../components/JSSForm/customRichTextField"));
var _customHidden = _interopRequireDefault(require("../../components/JSSForm/customHidden"));
var _customHiddenUTM = _interopRequireDefault(require("../../components/JSSForm/customHiddenUTM"));
var _customRadioButtonList = _interopRequireDefault(require("../../components/JSSForm/customRadioButtonList"));
var _customDropdown = _interopRequireDefault(require("../../components/JSSForm/customDropdown"));
var _customTelephone = _interopRequireDefault(require("../../components/JSSForm/customTelephone"));
var _customDatePicker = _interopRequireDefault(require("../../components/JSSForm/customDatePicker"));
var _customHiddenLeads = _interopRequireDefault(require("../../components/JSSForm/customHiddenLeads"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var GetApiKey = props => {
  var [sitecoreApiKey, setSitecoreApiKey] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    fetch('/apicalls/sitecoreApi').then(res => res.json()).then(result => {
      setSitecoreApiKey(result['id']);
    });
  }, []);
  return sitecoreApiKey;
};
exports.GetApiKey = GetApiKey;
var defaultFieldFactory = (0, _sitecoreJssReactForms.createDefaultFieldFactory)();
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.SingleLineText, props => /*#__PURE__*/_react.default.createElement(_customSingleLineText.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.MultipleLineText, props => /*#__PURE__*/_react.default.createElement(_customTextArea.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.Button, props => /*#__PURE__*/_react.default.createElement(_customButton.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.TextField, props => /*#__PURE__*/_react.default.createElement(_customTextField.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.Section, props => /*#__PURE__*/_react.default.createElement(_customSection.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.Checkbox, props => /*#__PURE__*/_react.default.createElement(_customCheckbox.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.RadioButtonList, props => /*#__PURE__*/_react.default.createElement(_customRadioButtonList.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.CheckboxList, props => /*#__PURE__*/_react.default.createElement(_customCheckboxList.default, props));
defaultFieldFactory.setComponent("{E383BDE2-BC88-4278-83EF-832A15C9E94A}", props => /*#__PURE__*/_react.default.createElement(_customRecaptcha.default, props));
defaultFieldFactory.setComponent("{F6ABF2D4-D864-48D7-A464-75025A42162E}", props => /*#__PURE__*/_react.default.createElement(_customRichTextField.default, props));
defaultFieldFactory.setComponent("{B67C70C1-6776-4BCB-8529-AA28E02F6412}", props => /*#__PURE__*/_react.default.createElement(_customHidden.default, props));
defaultFieldFactory.setComponent("{29A7FA8B-89C1-4900-A4B3-14551E95ACBC}", props => /*#__PURE__*/_react.default.createElement(_customHiddenUTM.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.DropdownList, props => /*#__PURE__*/_react.default.createElement(_customDropdown.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.Telephone, props => /*#__PURE__*/_react.default.createElement(_customTelephone.default, props));
defaultFieldFactory.setComponent(_sitecoreJssReactForms.FieldTypes.DateField, props => /*#__PURE__*/_react.default.createElement(_customDatePicker.default, props));
defaultFieldFactory.setComponent("{2A390930-E9B9-4A91-B2EC-BD53D3FA0F7F}", props => /*#__PURE__*/_react.default.createElement(_customHiddenLeads.default, props));
var GetPostData = props => {
  var state = _conditionalRendering.store.getState();
  var propsFormData = props.data;
  if (state && state.hiddenFields !== undefined) {
    state.hiddenFields.map(id => {
      propsFormData = propsFormData.filter(e => e.key !== id);
      propsFormData.push({
        key: id.replace('.Value', '.Required'),
        value: false
      });
      return propsFormData;
    });
  }
  props.data = propsFormData;
  return props.toMultipartFormData();
};
exports.GetPostData = GetPostData;
var formFetcher = (formData, endpoint) => {
  return fetch(endpoint, {
    body: GetPostData(formData),
    method: 'post',
    // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
    credentials: 'include'
    // Browser set 'Content-Type' automatically with multipart/form-data; boundary
  }).then(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (res) {
      var result = yield res.json();
      if (result.success === false && (0, _lodash.size)(result.validationErrors) === 1) {
        if (typeof window !== 'undefined') {
          if (window.readyForCaptcha === undefined) {
            window.readyForCaptcha = true;
          }
        }
      }
      GoToTop();
      return result;
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).catch(() => {
    return {
      success: false,
      errors: 'Our site is currently encountering an issue. Please try your submission later.'
    };
  });
};
var GoToTop = () => {
  if (document) {
    var top = document.getElementById('topOfForm');
    if (top) {
      top.scrollIntoView();
      if (window) {
        window.scrollBy(0, -108); //need to account for header over scrollable viewport 
      }
    }
  }
};
var ErrorList = errs => errs.map(err => {
  return /*#__PURE__*/_react.default.createElement("div", {
    key: err.id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "is-invalid"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "invalid-feedback"
  }, err));
});
;
var ErrorComponent = props => {
  (0, _conditionalRendering.default)(props.form.fields); //Sitecore react will call this component on each page
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    id: "formNumErrors",
    value: props.fieldErrors.length
  }), ErrorList(props.formErrors));
};
var JssForm = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    id: "topOfForm"
  }), /*#__PURE__*/_react.default.createElement(_sitecoreJssReactForms.Form, {
    form: props.fields,
    formFetcher: formFetcher,
    sitecoreApiHost: "",
    sitecoreApiKey: GetApiKey(),
    onRedirect: url => window.location.href = url.toLowerCase(),
    errorComponent: ErrorComponent,
    fieldFactory: defaultFieldFactory,
    conditionalFields: (0, _conditionalRendering.default)(props.fields.fields)
  }));
};
var _default = exports.default = JssForm;